export function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}